<div class="static-container">
  @if (imageUrl && !imageError) {
    <div class="image-wrapper">
      @if (!imageLoaded) {
        <div class="loading-indicator">
          <mat-progress-spinner diameter="40"></mat-progress-spinner>
          <p>Loading image...</p>
        </div>
      }
      <img 
        [src]="imageUrl" 
        [alt]="'Static content for ' + object()"
        class="static-image"
        [class.loaded]="imageLoaded"
        (load)="onImageLoad()"
        (error)="onImageError()" />
    </div>
  } @else if (imageError) {
    <div class="error-message">
      <mat-icon>error</mat-icon>
      <h3>Content not found</h3>
      <p>The requested static content "{{ object() }}" could not be loaded.</p>
    </div>
  }
</div>
